export const SLOT_NAMES = {
    LIVE_CAMPAIGN_SLOTS: 'liveCampaignSlots',
    FUTURE_CAMPAIGN_SLOTS: 'futureCampaignSlots',
    MISSED_CAMPAIGN_SLOTS: 'missedCampaignSlots',
};



// WEBPACK FOOTER //
// ./src/analytics/davinci/constants.js